import { clone } from '@jkhy/frontend-utils/functions';
import { CompanyUserTimeAccessDto as BoCompanyUserTimeAccessDto } from '@treasury/api/bo';
import { UserTimeAccess2Dto as ConsumerCompanyUserTimeAccessDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';
import { UserTimeAccessDay } from './user-time-access-day.entity';

const nullBoCompanyUserTimeAccess: BoCompanyUserTimeAccessDto = {
    timeRestricted: false,
    timeRestrictedPending: false,
    userId: 0,
    userTimeAccessDays: [],
    userTimeAccessDaysPending: [],
    success: false,
};

export class CompanyUserTimeAccess extends DomainEntity<
    BoCompanyUserTimeAccessDto | ConsumerCompanyUserTimeAccessDto
> {
    constructor(dto = clone(nullBoCompanyUserTimeAccess)) {
        super(dto);

        if (this.dto.userTimeAccessDays) {
            this.userTimeAccessDays = this.dto.userTimeAccessDays.map(
                day => new UserTimeAccessDay(day)
            );
        }
        if (this.dto.userTimeAccessDaysPending) {
            this.userTimeAccessDaysPending = this.dto.userTimeAccessDaysPending.map(
                day => new UserTimeAccessDay(day)
            );
        }
    }

    public userTimeAccessDays: UserTimeAccessDay[] = [];

    public userTimeAccessDaysPending: UserTimeAccessDay[] = [];

    public override toDto(): BoCompanyUserTimeAccessDto | ConsumerCompanyUserTimeAccessDto {
        const dto = super.toDto() as BoCompanyUserTimeAccessDto;
        dto.userTimeAccessDays = this.userTimeAccessDays.map(day => day.toDto());
        dto.userTimeAccessDaysPending = this.userTimeAccessDaysPending.map(day => day.toDto());
        return dto;
    }

    public createDefault(): this {
        return new CompanyUserTimeAccess(clone(nullBoCompanyUserTimeAccess)) as this;
    }

    public get restricted() {
        return this.dto.timeRestricted ?? false;
    }

    public set restricted(value: boolean) {
        this.dto.timeRestricted = value;
    }

    public get restrictedPending() {
        return this.dto.timeRestrictedPending ?? false;
    }

    public set restrictedPending(value: boolean) {
        this.dto.timeRestrictedPending = value;
    }
}
